import PortfolioManualTradeDetailTable from './PortfolioManualTradeDetailTable';

export default PortfolioManualTradeDetailTable;
